import { Component, inject, input, signal } from '@angular/core';
import { ParagraphPgPde } from '@app/models/paragraph.model';
import { Url } from '@app/models/global.model';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { MobiUiCarouselComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { CommonModule } from '@angular/common';
import { TextComponent } from '@app/components/text/text.component';
import { BreakpointService } from '@app/services/breakpoint.service';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { IconCtaComponent } from '@app/components/icon-cta/icon-cta.component';
import { OverlaySmallComponent } from '@app/components/product/product-damage-examples/overlay-small/overlay-small.component';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { CalcUrlPipe } from '@app/pipes/calc-url.pipe';

@Component({
  selector: 'mobi-product-damage-examples',
  templateUrl: './product-damage-examples.component.html',
  styleUrls: ['./product-damage-examples.component.scss'],
  imports: [
    ComponentSharedModule,
    MobiUiIconComponent,
    MobiUiCarouselComponent,
    CommonModule,
    TextComponent,
    ContentSectionComponent,
    IconCtaComponent,
    OverlaySmallComponent,
    CalcUrlPipe,
    MobiUiCarouselComponent,
  ],
  standalone: true,
})
export class ProductDamageExamplesComponent {
  readonly title = input('');
  readonly damageExamples = input.required<ParagraphPgPde[]>();
  readonly damageExampleCta = input<Url>();
  readonly calcUrl = input<string | undefined>();
  readonly anchorId = input<string>();

  overlayOpen = signal(false);
  currentExample = signal<ParagraphPgPde | undefined>(undefined);

  breakpoint = inject(BreakpointService);

  openOverlay(example: ParagraphPgPde) {
    this.currentExample.set(example);
    this.overlayOpen.set(true);
  }
}
